import { render, staticRenderFns } from "./LinkContract.vue?vue&type=template&id=ec1c589e&"
import script from "./LinkContract.vue?vue&type=script&lang=js&"
export * from "./LinkContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports